import axios from "axios";
import apiUrl from "../../../constants";
import commonFunction from "../../../commonFunction";
import constantVariable from "../../../constantVariable";

export default {
  name: "AdiComponent",

  data() {
    return {
      isLoading: false,
      pinCodeInput: "",
      cityInput: "",
      stateInput: "",
      addressInput: "",
      pinValidated: false,
      isAddressUpdated: false,
      CustomerDetails: {},
      ShipmentDetails: {},
      rawShipmentData: null,
      tempServiceCheckData: null,
    };
  },

  async mounted() {
    await this.fetchShippingIdByAlias();
  },

  methods: {
    async fetchShippingIdByAlias() {
      try {
        this.isLoading = true;

        const alias = this.$route.params.alias;
        if (!alias) {
          this.$alertify.error("Alias not found in URL");
          return;
        }

        const payload = { alias };
        const headers = commonFunction.getusertoken();

        const response = await axios.post(
          `${apiUrl.api_url}getShippingIdByAlias`,
          payload,
          { headers }
        );

        const data = response.data;
        if (!data || data.code !== 200) {
          const errorMsg =
            data && data.message ? data.message : "Failed to fetch shipping ID";
          this.$alertify.error(errorMsg);
        }

        const shippingId =
          data.data && data.data.shippingid ? data.data.shippingid : null;

        if (shippingId) {
          if (data.data && data.data.is_adi === true) {
            this.isAddressUpdated = true;
          }
          await this.fetchShipmentDetailsById(shippingId);
        } else {
          this.$alertify.error("Shipping ID not found for provided alias");
        }
      } catch (error) {
        this.$alertify.error("Error fetching shipping ID by alias");
      } finally {
        this.isLoading = false;
      }
    },

    async fetchShipmentDetailsById(shippingId) {
      try {
        this.isLoading = true;

        const payload = { shippingId };
        const headers = commonFunction.getusertoken();

        const response = await axios.post(
          `${apiUrl.api_url}getShipmentDetails`,
          payload,
          { headers }
        );

        const data = response.data;
        if (!data || data.code !== 200) {
          const errorMsg =
            data && data.message
              ? data.message
              : "Failed to fetch shipment details";
          this.$alertify.error(errorMsg);
        }

        const shipmentData =
          data.Data && data.Data.ShipmentDetails
            ? data.Data.ShipmentDetails
            : null;
        this.rawShipmentData = shipmentData;

        if (shipmentData) {
          this.CustomerDetails = {
            CustomerName:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.Name) ||
              "—",
            Address:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.Address) ||
              "—",
            City:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.City) ||
              "—",
            State:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.State) ||
              "—",
            PinCode:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.PinCode) ||
              "—",
            PhoneNo:
              (shipmentData.PrimaryPhone &&
                shipmentData.PrimaryPhone.PhoneNo) ||
              "—",
            EmailID:
              (shipmentData.CustomerPrimaryAddress &&
                shipmentData.CustomerPrimaryAddress.EmailID) ||
              "—",
          };

          this.ShipmentDetails = {
            ShippingId: shipmentData.ShippingID || "—",
            ClientName:
              (shipmentData.ShipmentDetails &&
                shipmentData.ShipmentDetails.BusinessAccountName) ||
              "—",
            ServiceType:
              (shipmentData.ShipmentDetails &&
                shipmentData.ShipmentDetails.ServiceType) ||
              shipmentData.ServiceType ||
              "—",
            ShipmentStatus:
              (shipmentData.ShipmentDetails &&
                shipmentData.ShipmentDetails.ShipmentStatus) ||
              shipmentData.ShipmentStatus ||
              "—",
          };

          this.tempServiceCheckData = {
            businessunit:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.BusinessType,
            businessflow:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.BusinessFlow,
            businessservice:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.businessService,
            ClientBusinessAccountID:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.ClientBusinessAccountID,
            routemode: shipmentData.RouteMode,
            orderType:
              shipmentData.OrderDetails && shipmentData.OrderDetails.OrderType,
            ServiceType:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.ServiceType,
            deliveryType:
              shipmentData.ShipmentDetails &&
              shipmentData.ShipmentDetails.deliveryType,
          };
        }
      } catch (error) {
        this.$alertify.error("Error fetching shipment details");
      } finally {
        this.isLoading = false;
      }
    },

    async createTicketPayload() {
      try {
        if (!this.rawShipmentData) {
          this.$alertify.error("Please fetch shipment details first");
          return;
        }

        const s = this.rawShipmentData;
        const BusinessFlow =  this.tempServiceCheckData.businessflow
        const payload = {
          IsFakeNDRStatus: constantVariable.IsFakeNDRStatus,
          SourceName: constantVariable.SourceName,
          action: constantVariable.action,
          address: this.addressInput,
          businessflow: s.ShipmentDetails.BusinessFlow,
          businessservice: this.tempServiceCheckData.businessservice,
          businessunit: s.ShipmentDetails.businessService,
          clientID: s.ClientID,
          comments: constantVariable.comments,
          deptid: constantVariable.deptid,
          emailAddress: s.CustomerPrimaryAddress.EmailID,
          emailCasesArrayForUpdate: [],
          escalation: constantVariable.escalation,
          flag: constantVariable.flag,
          isLatestOfd: constantVariable.isLatestOfd,
          location: constantVariable.location,
          notificationStatus: s.ShipmentDetails.notificationStatus,
          notificationType: s.ShipmentDetails.notificationType,
          orderTypeId: s.OrderDetails && s.OrderDetails.OrderType,
          pincode: this.pinCodeInput,
          pincodebusinessflow: BusinessFlow == 'Reverse'? constantVariable.pincodebusinessflow_fwd : constantVariable.pincodebusinessflow_rev ,
          prexoShipment: null,
          prexoType: null,
          reasonId: constantVariable.reasonId,
          routemode: constantVariable.routemode,
          shippingData: [
            {
              index: 0,
              shippingData: {
                ShippingID: s.ShippingID,
                CurrentHubID:
                  s.ShipmentDetails && s.ShipmentDetails.CurrentHubID,
                TotalAttemptCount:
                  s.ShipmentDetails && s.ShipmentDetails.TotalAttemptCount,
                ClientName:
                  s.ShipmentDetails && s.ShipmentDetails.BusinessAccountName,
                CreatedDate: s.ShipmentDetails && s.ShipmentDetails.CreatedDate,
                CurrentStatus:
                  s.ShipmentDetails && s.ShipmentDetails.ShipmentStatus,
                OrderType: s.OrderDetails && s.OrderDetails.OrderType,
                Status: s.ShipmentDetails && s.ShipmentDetails.Status,
                BusinessFlow: s.BusinessFlow,
              },
            },
          ],
          sourceId: constantVariable.sourceId,
          subReason: BusinessFlow == 'Reverse'? constantVariable.subReasonId_REV : constantVariable.subReason_FWD,
          subReasonId: BusinessFlow == 'Reverse'? constantVariable.subReasonId_REV : constantVariable.subReasonId_FWD,
          ticketStatusId: constantVariable.ticketStatusId,
          ticketTypeId: constantVariable.ticketTypeId,
          userId: constantVariable.userId,
          userProcess: BusinessFlow == 'Reverse'? constantVariable.userProcess_REV: constantVariable.userProcess_FWD,
          userType: constantVariable.userType,
          username: constantVariable.username,
        };

        return payload;
      } catch (error) {
        this.$alertify.error("Error creating ticket payload");
      }
    },
    async validatePin() {
      try {
        if (!this.pinCodeInput || !/^\d{6}$/.test(this.pinCodeInput)) {
          this.$alertify.error("Pin Code must be  6 digits");
          return;
        }
        if (!this.tempServiceCheckData && !this.rawShipmentData) {
          this.$alertify.error("Shipment details not loaded yet");
          return;
        }

        const sd = this.tempServiceCheckData || {};
        const input = {
          businessunit: sd.businessunit,
          businessflow: sd.businessflow,
          businessservice: sd.businessservice,
          ClientBusinessAccountID: sd.ClientBusinessAccountID,
          pincode: String(this.pinCodeInput),
          routemode: sd.routemode,
          orderType: sd.orderType,
          ServiceType: sd.ServiceType,
          deliveryType: sd.deliveryType,
        };

        const headers = commonFunction.getusertoken();
        const response = await axios.post(
          `${apiUrl.api_url}checkPincodeServiceables`,
          input,
          { headers }
        );

        const body = response.data;

        if (body.status === 200 && body.ErrorCode === 0) {
          this.cityInput = body.data.cityName;
          this.stateInput = body.data.stateName;
          this.pinValidated = true;
          this.$alertify.success(body.msg || "Pincode validated successfully");
        } else {
          this.cityInput = "";
          this.stateInput = "";
          this.pinValidated = false;
          this.$alertify.error(body.msg || "Pincode not serviceable");
        }
      } catch (err) {
        this.cityInput = "";
        this.stateInput = "";
        this.pinValidated = false;
        this.$alertify.error("Error validating pin code");
      }
    },

    async submitAddress() {
      try {
        this.isLoading = true;
        const addressLength = this.addressInput.trim().length;
        if (addressLength < 3 || addressLength > 200) {
          this.$alertify.error("Address must be between 3 and 200 characters");
          return;
        }

        if (!/^\d{6}$/.test(this.pinCodeInput)) {
          this.$alertify.error("Pin Code must be  6 digits");
          return;
        }
        if (!this.pinValidated) {
          this.$alertify.error("Please validate Pin Code first!");
          this.isLoading = false;
          return;
        }

        const payload = await this.createTicketPayload();
        const headers = commonFunction.getusertoken();
        const response = await axios.post(
          `${apiUrl.api_url}updateAdiAddress`,
          payload,
          { headers }
        );

        const data = response.data;
        if (data && data.status === 200) {
          this.$alertify.success(
            data.message ? data.message : "Address updated successfully!"
          );
          this.isAddressUpdated = true;
        } else {
          this.$alertify.error(
            data && data.message ? data.message : "Failed to update address"
          );
        }
      } catch (error) {
        this.$alertify.error("Error while updating address");
      } finally {
        this.isLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/adi/adi.component.js